import AssistantMergeApproval from "./AssistantMergeApproval";
import AssistantToolApproval from "./AssistantToolApproval";

/**
 * Which card an approval draws itself as.
 *
 * There used to be exactly one thing the assistant asked permission for, so the chat item imported
 * the merge card directly. Campaign writes add a second on feat/training-management, and they are
 * nothing like a merge to look at — one is two profiles side by side, the other a list of fields
 * changing value — so the choice lives here rather than in branches inside the chat item.
 *
 * The merge card is still the fallback for an approval that names no tool, or names
 * merge_profiles: the payload in production today carries no `kind` at all. Any other tool gets
 * the plain confirmation — drawn as a merge, a read tool missing from mcpAutoApproveTools read
 * "Confirm this merge — Profile null".
 */
const RENDERERS = {
    merge: AssistantMergeApproval,
    merge_profiles: AssistantMergeApproval,
    tool: AssistantToolApproval,
};

/* The server sends the tool as `tool`; `toolName` is accepted too, as the payload is spelled in
   AssistantService. */
const toolOf = (approval) => (approval ? approval.tool || approval.toolName : null);

const namesAnotherTool = (approval) => {
    const tool = toolOf(approval);
    return Boolean(tool && tool !== "merge_profiles");
};

/* Conversations archived before "tool" existed carry kind "merge" on every approval, whatever it
   was for. One that names another tool is drawn as the confirmation it was. A kind this registry
   does not know — the server sends a tool's own name for any tool it has no mapping for — is the
   plain confirmation too, unless the tool is a merge. */
const kindOf = (approval) => {
    if (!approval) return null;
    if (approval.kind === "merge" && namesAnotherTool(approval)) return "tool";
    return approval.kind;
};

export const approvalRenderer = (approval) =>
    RENDERERS[kindOf(approval)] || (namesAnotherTool(approval) ? AssistantToolApproval : AssistantMergeApproval);

export default approvalRenderer;
